const BARCODE_SCANNING_EVENT = 'BarcodeScanningEvent'

const ORDER_DETAIL_FORM_OPEN_EVENT = 'OrderDetailFormOpenEvent'

const ORDER_WITH_SMS_FORM_OPEN_EVENT = 'OrderWithSMSFormOpenEvent'

const TOKEN_SESSION_EXPIRED_EVENT = 'TokenSessionExpiredEvent'

const HUB_CONNECTING_EVENT = 'HubConnectingEvent'

const HUB_CONNECTED_EVENT = 'HubConnectedEvent'

const HUB_DISCONNECTED_EVENT = 'HubDisconnectedEvent'

const LOG_OUT_EVENT = 'LogoutEvent'

export {
    BARCODE_SCANNING_EVENT,
    ORDER_DETAIL_FORM_OPEN_EVENT,
    ORDER_WITH_SMS_FORM_OPEN_EVENT,
    TOKEN_SESSION_EXPIRED_EVENT,
    HUB_CONNECTING_EVENT,
    HUB_CONNECTED_EVENT,
    HUB_DISCONNECTED_EVENT,
    LOG_OUT_EVENT
}